import Column from '@components/Column';
import Header from '@components/Header';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CsContents from './components/CsContents';
import CsDescription from './components/CsDescription';

const CustomerServiceActivity: ActivityComponentType = () => {
    const { t } = useTranslation('customerService');
    return (
        <AppScreen>
            <Header title={t('header.title')} noShadow/>
            <Container spacing={24} fullWidth align='center'>
                <CsDescription />
                <CsContents/>
            </Container>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 16px;
`;

export default CustomerServiceActivity;
